import gql from 'graphql-tag'
export default gql`
  query Toaster {
    Toaster @client {
      header
      message
      color
      type
      mobile
      showToaster
    }
  }`
